/** Faint centered club emblem behind the screen content (Home / Profile). */
export function Watermark() {
  return <img className="bg-watermark" src="/logo.png" alt="" aria-hidden="true" />;
}
